(function (angular) {
    'use strict';
    angular.module("dentist").controller('errorController', errorController);

    function errorController($translate, $state, $stateParams) {

        //controller initialization
        var ctrl = this;
        ctrl.gotoHome = gotoHome;
        ctrl.isStandaloneBooking = $stateParams.standalone;

        function gotoHome() {
            $state.go("home");
        }

        function changeLanguage(langKey) {
            $translate.use(langKey);
            localStorage.setItem("lang", langKey);
        }
    }

    errorController.$inject = ['$translate', '$state', '$stateParams'];

})(window.angular);
